import admin from "./admin";
import rallyOfficer from "./rally-officer";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [rallyOfficer, admin],
};

export default menuItems;
